import { ExternalTawkInfoFragment, TawkInfoV2Fragment } from "../API";
import { GenericImageConfig } from "../Components/GenericImageComponent/GenericImageComponent";
import { PlayablePayload } from "../Components/InlinePlayableTawkPill/InlinePlayableTawkPill";

export type PlayableEntity = TawkInfoV2Fragment | ExternalTawkInfoFragment;

export type AuthorlikeConfig = {
  name: string;
  userHandleLike: string;
  profilePic: GenericImageConfig;
};

export function authorlikeConfig(
  playableEntity: PlayableEntity
): AuthorlikeConfig {
  if (playableEntity.__typename === "TawkCandidate") {
    return {
      name: playableEntity.author.name ?? "Unknown",
      userHandleLike:
        playableEntity.author.userHandle?.renderedForm ?? "unknown",
      profilePic: {
        kind: "CloudinaryImageConfig",
        publicId: playableEntity.author.profilePhoto.publicId,
      },
    };
  } else {
    return {
      name: playableEntity.originName,
      userHandleLike: playableEntity.originName,
      profilePic: {
        kind: "UrlImageConfig",
        url: playableEntity.picture.imageUrl,
      },
    };
  }
}

export function playablePaylaod(
  playableEntity: PlayableEntity
): PlayablePayload {
  if (playableEntity.__typename === "TawkCandidate") {
    return {
      kind: "CloudinaryVideoPayload",
      publicId:
        playableEntity.generatedVideo?.publicId ??
        playableEntity.processedAudio?.publicId ??
        playableEntity.rawAudio.publicId,
    };
  } else {
    return {
      kind: "AudioUrl",
      url: playableEntity.audioFileUrl,
    };
  }
}
